<template>
  <section
    style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    "
  >
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-btn @click="addCard = !addCard" class="info ml-6 mr-2 mt-4">
              <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
              Ajouter un nouveau Author
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="addCard">
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-1">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajouter un nouveau Auteur</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="AuthorName"
                    label="Nom"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="AuthorSubtitle"
                    label="Subtitle"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="AuthorSubtitleEn"
                    label="Subtitle en anglais"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <h3>Bibliography</h3>
                  <VueEditor
                    v-model="AuthorBibliography"
                    auto-grow
                    outlined
                    label="phonetic"
                    placeholder="Bibliography"
                    required
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <h3>Bibliography en anglais</h3>
                  <VueEditor
                    v-model="AuthorBibliographyEn"
                    auto-grow
                    outlined
                    placeholder="Bibliography en anglais"
                    required
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <h3>Certification</h3>
                  <VueEditor
                    v-model="AuthorCertificate"
                    auto-grow
                    outlined
                    label="phonetic"
                    placeholder="Certification"
                    required
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="expertSelected"
                    :items="ExpertArray"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    chips
                    small-chips
                    label="Experts"
                    multiple
                  >
                    <template #item="{ item }">
                      <v-list-item @click="toggleItem(item)">
                        <v-list-item-action>
                          <v-checkbox
                            color="primary"
                            :input-value="isSelected(item)"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="websiteUrl"
                    label="websiteUrl"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" v-if="AuthorName">
                  <vue-upload-multiple-image
                    :idUpload="imagesId"
                    v-model="images"
                    :data-images="images"
                    accept="image/*	"
                    name="images"
                    drag-text="Veuillez ajoutez une image"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @images-updated="handleImagesUpdated"
                  >
                  </vue-upload-multiple-image>
                  <h1 v-if="loadingimage">En cours de upload image</h1>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="
                        AuthorName.length <= 0 ||
                        AuthorBibliography.length <= 0 ||
                        AuthorCertificate.length <= 0 ||
                        !imageId
                      "
                      class="info"
                      @click="validate"
                      :loading="isButtonLoading"
                    >
                      {{ isButtonLoading ? "Chargement..." : "Sauvgarde" }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Auteur</v-card-title>
      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>
      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        :headers="headers"
        :items="AuthorArray"
        class="elevation-1"
        item-key="id"
      >
        <template v-slot:[`item.imgUrl`]="{ item }">
          <v-img
            v-if="item.imgDBType != 'svg'"
            :src="item.imgUrl"
            width="65"
            height="65"
          />
          <div
            v-if="item.imgDBType === 'svg'"
            v-html="item.svgContent"
          ></div>
        </template>

        <template v-slot:[`item.expertResponseList`]="{ item }">
          <div class="expert-list-container">
            <ul class="expert-list">
              <li
                v-for="expert in item.expertResponseList"
                :key="expert.id"
                class="expert-item"
              >
                {{ expert.name }}
              </li>
            </ul>
          </div>
        </template>

        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditAuthor(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.id)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddTheme" max-width="530">
        <v-card class="pa-6 pa-sm-6" max-width="600px">
          <v-card-title style="text-align: center" class="justify-center mb-2"
            >Etes vous sur de vouloir ajouter le Auteur
          </v-card-title>
          <v-card-subtitle
            class="text-h6 mb-3"
            style="text-align: center; color: #24aeb1"
            >{{ AuthorName }}
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="ajoutAuthor()"
              :color="loadingbtn ? 'grey' : 'info'"
              :disabled="loadingbtn"
            >
              <span v-if="!loadingbtn">Confirmer</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
            <v-btn
              :color="loadingbtn ? 'grey' : 'error'"
              :disabled="loadingbtn"
              @click="reinitialisationFormulaire()"
            >
              <span v-if="!loadingbtn">Annuler</span>
              <v-progress-circular
                v-if="loadingbtn"
                size="24"
                color="white"
                indeterminate
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteAuthor" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le Author ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteAuthor = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteAuthor()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.visible"
      :top="snackbar.position === 'top'"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";

import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { mdiDeleteOutline, mdiPencil, mdiDatabasePlusOutline } from "@mdi/js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import Constant from "@/utils/constants";
import { getAllAuthor, getAllExpert } from "@/views/qorani/services/services";
import store from "../../../store/image";
import axios from "axios";
import constants from "@/utils/constants";

export default {
  components: { VueUploadMultipleImage, VueEditor },
  data() {
    return {
      snackbar: {
        position: "top",
        timeout: 3000,
        color: null,
        text: "",
        visible: false,
      },
      expertSelected: [],
      showlowding: null,
      search: "",
      addCard: false,
      loadingbtn: false,
      icons: {
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
      },
      ExpertArray: [],
      valid: true,
      AuthorName: "",
      AuthorSubtitle: "",
      websiteUrl: "",
      AuthorBibliography: "",
      AuthorCertificate: "",
      suratName: "",
      loadingimage: false,
      imageId: null,
      Author: {
        name: "",
        bibliography: "",
      },
      dialogAddTheme: false,
      AuthorArray: [],
      isLoadingTables: false,
      headers: [
        { text: "Image", value: "imgUrl" },
        { text: "Name", value: "name" },
        { text: "Subtitle", value: "subtitle" },
        { text: "Subtitle en anglais", value: "subtitleEn" },
        { text: "Bibliography", value: "bibliography" },
        { text: "Bibliography en anglais", value: "bibliographyEn" },
        { text: "Certification", value: "certification" },
        { text: "WebsiteUrl", value: "websiteUrl" },
        { text: "Expert", value: "expertResponseList" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      dialogDeleteAuthor: false,
      load: false,
      isButtonLoading: false,
      idAuthorSupprimer: "",
      images: [],
      imagesId: "1",
    };
  },
  methods: {
    isSelected(item) {
      return this.expertSelected.includes(item.id);
    },
    toggleItem(item) {
      if (this.isSelected(item)) {
        this.expertSelected = this.expertSelected.filter(
          (id) => id !== item.id
        );
      } else {
        this.expertSelected.push(item.id);
      }
    },
    async loadImage(item) {
      if (item.imgDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.imgDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');
          this.$set(item, 'svgContent', svgContent);
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        this.$set(item, 'imgUrl', `${Constant.QORANI}fileDB/files/${item.imgDBId}`);
      }
    },

    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    async uploadImageSuccess(formData, index, fileList) {
      this.loadingimage = true;

      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        this.imageId = store.state.imageId;
        this.Author.imgDBUrlId = imageId;
        console.log("Image id :", this.imageId);
        this.loadingimage = false;
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUpload.indexOf(
          fileList[index].path
        );
        this.imageUrl = "";
        this.imageId = "";
        if (index > -1) {
          this.imagesUpload.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    handleImagesUpdated(images) {
      this.loadingimage = true;
      const uploadedImage = images[0];
      console.log("Uploaded image:", uploadedImage);
    },
    redirectToEditAuthor(item) {
      this.$router.push({
        name: "EditAuthor",
        params: { id: item.id, item: item },
      });
    },
    suppressionAction(item) {
      this.idAuthorSupprimer = item;
      // this.dialogDeleteAuthor = true;
      this.deleteAuthor();
    },
    async deleteAuthor() {
      try {
        const responseCategorie = await fetch(
          Constant.QORANI +
            `authorCertificate/delete/${this.idAuthorSupprimer}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (responseCategorie.ok) {
          this.AuthorArray = await getAllAuthor();
          this.dialogDeleteAuthor = false;
          this.snackbar.text = "L'auteur a été supprimé avec succès !";
          this.snackbar.color = "success";
          this.snackbar.visible = true;
        } else {
          this.dialogDeleteAuthor = false;
          this.snackbar.text = "Erreur lors de la suppression";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } catch (error) {
        this.dialogDeleteAuthor = false;
        this.snackbar.text =
          "Une erreur est survenue lors de la suppression de l'auteur. Veuillez réessayer plus tard.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
        this.dialogDeleteAuthor = false;
      }
    },
    async addExpertToAuthor(expertSelected, authorId) {
      try {
        console.log(expertSelected);

        expertSelected.map(async (expertId) => {
          const res = await axios.get(
            `${constants.QORANI}authorCertificate/addExpert/${expertId}/toCertificate/${authorId}`
          );
        });
      } catch (error) {
        this.snackbar.text =
          "Une erreur est survenue lors de l'ajout de l'auteur. Veuillez réessayer plus tard.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
      this.AuthorArray = await getAllAuthor();
      this.AuthorName = "";
      this.AuthorBibliography = "";
      this.AuthorCertificate = "";
      this.snackbar.text = "L'auteur a été ajouté avec succès !";
      this.snackbar.color = "success";
      this.snackbar.visible = true;
    },

    async ajoutAuthor() {
      const imageId = store.state.imageId;
      this.Author.name = this.AuthorName;
      this.Author.bibliography = this.AuthorBibliography;
      this.Author.certification = this.AuthorCertificate;
      this.Author.subtitle = this.AuthorSubtitle;
      this.Author.websiteUrl = this.websiteUrl;
      console.log(this.Author);

      try {
        const response = await fetch(
          Constant.QORANI + "authorCertificate/add",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.Author),
          }
        );

        if (response.ok) {
          const data = await response.json();

          if (this.expertSelected.length > 0) {
            this.addExpertToAuthor(this.expertSelected, data.id);
          } else {
            this.AuthorArray = await getAllAuthor();
            this.AuthorName = "";
            this.AuthorBibliography = "";
            this.AuthorCertificate = "";
            this.snackbar.text = "L'auteur a été ajouté avec succès !";
            this.snackbar.color = "success";
            this.snackbar.visible = true;
          }
        } else {
          this.snackbar.text = "Erreur lors de l'ajout de l'auteur";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } catch (error) {
        this.snackbar.text =
          "Une erreur est survenue lors de l'ajout de l'auteur. Veuillez réessayer plus tard.";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.ajoutAuthor();
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddTheme = false;
      this.$refs.form.reset();
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.AuthorArray = await getAllAuthor();
    this.AuthorArray.forEach(async (item) => {
      console.log(item);

      if (item.imgDBId) {
        await this.loadImage(item);
      }
    });

    this.ExpertArray = await getAllExpert();
    this.isLoadingTables = false;
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
